import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { share, tap } from 'rxjs/operators';
import { CookieWrapperService } from '../cookie-wrapper/cookie-wrapper.service';
import { RouteReuseStrategyService } from '../route-reuse-strategy-service/route-reuse-strategy-service.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public isFirstRun = true;

  public track = true;
  public url = null;

  private _getOrgUserObservable = null;
  private _orgUser = null;
  public set orgUser(orgUser) {
    if(orgUser.id) {
      this._orgUser = orgUser;
      window['localOrgData']['user'] = orgUser;
    }

    if(_.has(orgUser, 'access_token')) {
      this.cookieWrapperService.setAccessTokenCookie(orgUser.access_token);
    }

    if(_.has(orgUser, 'orgUserAccountInfo')) {
      this.orgUserAccountInfo = orgUser.orgUserAccountInfo;
    }
  }
  public get orgUser() {
    return this._orgUser;
  }

  private _orgUserAccountInfo = null;
  public set orgUserAccountInfo(orgUserAccountInfo) {
    this._orgUserAccountInfo = orgUserAccountInfo;
    window['localOrgData']['orgUserAccountInfo'] = orgUserAccountInfo;

    if(_.has(orgUserAccountInfo, 'access_token')) {
      this.cookieWrapperService.setAdminAccessTokenCookie(orgUserAccountInfo.access_token);
    }
  }
  public get orgUserAccountInfo() {
    return this._orgUserAccountInfo;
  }

  private _adminUserInfo = null;
  public set adminUserInfo(adminUserInfo) {
    this._adminUserInfo = adminUserInfo;
    window['localOrgData']['orgUserAccountInfo'] = adminUserInfo;
  };
  public get adminUserInfo() {
    return this._adminUserInfo;
  }

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private cookieWrapperService: CookieWrapperService,
    private routeReuseStrategyService: RouteReuseStrategyService
  ) { }

  signin(email, password) {
    const queryParams = [
      `p=${encodeURIComponent(JSON.stringify({email,password}))}`
    ];
    return this.http.post('/api/org/signIn', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getOrgUser(reload = false): Observable<any> {

    if(this.orgUser && !reload) {
      return of(this.orgUser);
    }

    if(this._getOrgUserObservable instanceof Observable && !reload) {
      return this._getOrgUserObservable;
    }

    const token = this.cookieService.get('accessToken');
    this._getOrgUserObservable = this.http.post('/api/orgUser', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(
      tap(orgUser => {
        this.orgUser = orgUser;
      }),
      share()
    )
    return this._getOrgUserObservable;
  }

  resetOrgUserObservable() {
    this._getOrgUserObservable = null;
  }

  switchOrgUser(destOrgId) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
      `access_token=${token}`,
      `destOrgId=${destOrgId}`
    ];
    return this.http.post('/api/org/login/switch', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(
      tap(orgUser => {
        this.orgUser = orgUser;
      })
    )
  }

  getOrgAccounts() {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/getOrgAccounts', `access_token=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getAdminUserInfo() {
    if(this.adminUserInfo) {
      return of(this.adminUserInfo);
    }

    const token = this.cookieService.get('adminAccessToken');
    return this.http.post('/api/org/adminUserInfo', `adminAccessToken=${token}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(
      tap(adminUserInfo => {
        this.adminUserInfo = adminUserInfo;
      })
    )
  }

  loginAs(destOrgId) {
    const token = this.cookieService.get('adminAccessToken');
    const queryParams = [
      `access_token=${token}`,
      `destOrgId=${destOrgId}`
    ];
    return this.http.post('/api/org/loginAs', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    }).pipe(
      tap(orgUser => {
        this.orgUser = orgUser;
      })
    )
  }

  reset() {
    this.routeReuseStrategyService.status = false;

    this._orgUser = null;
    this._orgUserAccountInfo = null;
    this._adminUserInfo = null;
  }
}
